import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Button from "./Button";

export interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPrev: () => void;
  onNext: () => void;
  disabled?: boolean;
  className?: string;
}

/** Prev / page-indicator / Next row shared by the blog, movie, and puzzle lists. */
const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPrev,
  onNext,
  disabled = false,
  className = "",
}) => (
  <div className={`flex items-center justify-between gap-4 px-6 py-5 ${className}`}>
    <Button
      variant="subtle"
      size="sm"
      onClick={onPrev}
      disabled={currentPage <= 1 || disabled}
      leftIcon={<ChevronLeft className="h-4 w-4" />}
    >
      Previous
    </Button>
    <span className="text-sm text-gray-400">
      Page <span className="font-semibold text-gray-200">{currentPage}</span> of{" "}
      {totalPages}
    </span>
    <Button
      variant="subtle"
      size="sm"
      onClick={onNext}
      disabled={currentPage >= totalPages || disabled}
      rightIcon={<ChevronRight className="h-4 w-4" />}
    >
      Next
    </Button>
  </div>
);

export default Pagination;
